export const gllOptions = [
  { value: { occurrence: 500000, aggregate: 1000000 }, label: "$500K/$1M" },
  { value: { occurrence: 1000000, aggregate: 1000000 }, label: "$1M/$1M" },
  { value: { occurrence: 1000000, aggregate: 2000000 }, label: "$1M/$2M" },
  { value: { occurrence: 1000000, aggregate: 3000000 }, label: "$1M/$3M" },
  { value: { occurrence: 1000000, aggregate: 4000000 }, label: "$1M/$4M" },
  { value: { occurrence: 1000000, aggregate: 5000000 }, label: "$1M/$5M" },
  { value: { occurrence: 2000000, aggregate: 2000000 }, label: "$2M/$2M" },
];
